import axios         from 'axios';
import { addErrors } from 'cfg/errorBag';

axios.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

axios.interceptors.response.use((response)=> response, (error)=> {

  const rejection = error.response;

  if(rejection.status == 422 && rejection.data.errors) {
    const errors   = rejection.data.errors.list;
    const messages = Object.keys(errors).map((key)=> {
      return { key, error: errors[key] };
    });
    addErrors(messages);
  }

  return Promise.reject(error.response);
});
